var map = {
	"./ayla.png": "e32b",
	"./gm-bv.png": "f9d2",
	"./gm-mb.png": "2e1e",
	"./gm-pu.png": "c1d0",
	"./himax.png": "e868",
	"./luxio.png": "c79d",
	"./sigra.png": "80af",
	"./sirion.png": "d126",
	"./terios.png": "9ff7",
	"./xenia.png": "4e4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0ca";